import "./index.scss";
import PropTypes from "prop-types";
import classnames from "classnames";
import React from "react";
import icon from '../../../assets/icons/chevron-down.svg';
import TextField from "@material-ui/core/TextField";

export class Input extends React.Component {

  static propTypes = {
    onChange: PropTypes.func,
    type: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    rightIcon: PropTypes.node,
    showPassword: PropTypes.func,
  };

  static defaultProps = {
    onChange: null,
    type: "text",
    label: "",
    value: "",
    placeholder: "",
    readOnly: false,
    rightIcon: null,
    showPassword: null,
  };

  getDynamicProps() {
    const { value } = this.props;
    const res = {};

    if (value !== null || typeof value !== "undefined") {
      res.value = value;
    }

    return res;
  }

  render() {
    const { type, rightIcon, rightIcon2, readOnly, label, showPassword, placeholder, onChange, params, name, required, max, min, disabled, t } = this.props;
    return (
      <label className={classnames("input", {
        readOnly: readOnly,
        hasRightIcon: !!rightIcon,
      })}>
        {label && <span>{t(label)}</span>}

        <TextField
          variant="filled"
          readOnly={readOnly}
          placeholder={t(placeholder)}
          onChange={onChange}
          type={type}
          disabled={disabled}
          {...this.getDynamicProps()}
          InputProps={{
            inputProps: {
              maxLength: max, minLength: min
            }
          }}
          params={params}
          name={name}
          required={required}
        />

        {rightIcon && (
          <div className="right-icon" onClick={(e) => showPassword && showPassword(name)}>
            {showPassword && type !== 'password' ? rightIcon2 : rightIcon}
          </div>
        )}
      </label>
    );
  }
}